export const onSlackEvent = /* GraphQL */ `
  subscription OnSlackEvent($channel: String!) {
    onSlackEvent(channel: $channel) {
      type
      channel
      user
      userImage
      text
      ts
      eventType
      thread_ts
      originalText
      additionalData
      parentTS
      parentText
      parentUserImage
      parentUserName
    }
  }
`;
